import { render, staticRenderFns } from "./SalesList.html?vue&type=template&id=5d3f3e55&scoped=true&"
import script from "./SalesList.js?vue&type=script&lang=js&"
export * from "./SalesList.js?vue&type=script&lang=js&"
import style0 from "./SalesList.scss?vue&type=style&index=0&id=5d3f3e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f3e55",
  null
  
)

export default component.exports